export const REQUEST_LOG_IN_AGAIN = {
  code: 4007,
  msg: '身份验证失败，请重新登录！',
}
export const SERVER_ERROR = {
  code: 500,
  msg: '后台服务器出错，操作失败！',
}
